import styled from '@emotion/styled';

export default styled.input`
	border: 1px solid #999;
	box-sizing: border-box;
	color: #333333;
	flex: 0 1 auto;
	font-size: 16px;
	font-weight: 400;
	height: 40px;
	min-width: 4em;
	padding: 0 10px;
	text-align: right;
	width: auto;

	${props => props.theme.input || ''}

	&[type="number"] {
		&::-webkit-outer-spin-button,
		&::-webkit-inner-spin-button {
			-webkit-appearance: none;
			margin: 0;
		}
		-moz-appearance: textfield;
	}
`;

export const InputWrap = styled.div`
	align-items: center;
	align-content: center;
	display: flex;

	${props => props.theme.inputWrap || ''}
`;
